import { useSetRecoilState } from "recoil";
import api from "../library/Axios.jsx";
import api_file from "../library/AxiosMedia.jsx";
import AuthState from "../atoms/AuthState.jsx";
import {
  deleteToken,
  deleteUser,
  saveToken,
  saveUser,
  loadToken,
} from "../component/action/preferences.jsx";
import { useTokenAndUser } from "../component/action/userData.jsx";

export default useAuthenticate;

function useAuthenticate() {
  const setAuth = useSetRecoilState(AuthState);
  const { token, user, amounts, isLoading, checkTokenChange } =
    useTokenAndUser();
  return {
    global,
    auth,
    login,
    logout,
    register,
    get_verify_code,
    forgot_password,
    update_password,

    game_list,
    spin_create,

    withdrawal,
    withdrawal_bank,
    member_withdrawal_bank,
    get_withdrawal_limit,

    notifications,

    //promotion
    bonus_a_page_list,

    //deposit
    deposit_frontend,
    deposit,
    deposit_check,
    deposit_cancel,
    
  };

  async function global(form = {}) {
    try {
      const res = await api.post("global", form);
      const data = res.data;
      if (!data.status) {
        return data;
      }

      return data;
    } catch (error) {
      return { status: false, message: "Failed while fetching global data" };
    }
  }

  async function login(form) {
    try {
      const res = await api.post("login", form);
      const data = res.data;
      if (!data.status) {
        return data;
      }

      await saveToken(data.token);
      await saveUser(data.data);
      await checkTokenChange();

      return data;
    } catch (error) {

      return { status: false, message: "Login failed" };
    }
  }

  async function auth() {
    try {
      const token = await loadToken();
      if (token != null) {
        const res = await api.post("user");
        const data = res.data;

        if (!data.status) {
          await deleteToken();
          await checkTokenChange();
          return data;
        }

        await saveToken(data.token);
        await saveUser(data.data);
        await checkTokenChange();

        return data;
      } else {
        return { status: false, message: "TOKEN null , Authentication failed" };
      }
    } catch (error) {
      return { status: false, message: "Authentication failed" };
    }
  }

  async function logout() {
    await deleteToken();
    await deleteUser();

    setAuth((prev) => ({
      ...prev,
      token: null,
      isLogin: false,
      user: null,
    }));

    return true;
  }

  async function register(form = {}) {
    try {
      const res = await api.post("register", form);
      const data = res.data;
      if (!data.status) {
        return { status: false, message: data.message || "Registration failed" };
      }

      return data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed while registering";
      return { status: false, message };
    }
  }

  async function get_verify_code(form = {}) {
    try {
      const res = await api.post("get_verify_code", form);
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to send verification code";
      return { status: false, message };
    }
  }

  async function update_password(form) {
    return api
      .post("update_password", form)
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }

        return res;
      });
  }

  async function forgot_password(form) {
    return api
      .post("forget_password", form)
      .then((res) => res.data)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return { status: false, message: "Internal Server Error" };
      });
  }

  async function game_list(form = {}) {
    try {
      const res = await api.post("game_list", form);
      const data = res.data;
      if (!data.status) {
        return data;
      }

      return data;
    } catch (error) {
      return { status: false, message: "Failed while fetching game list" };
    }
  }

  async function spin_create() {
    return api
      .post("spin_create", "")
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }
        return res;
      });
  }

  async function notifications() {
    return api
      .post("notifications")
      .then((res) => res.data)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return { status: false, message: "Internal Server Error" };
      });
  }

  async function withdrawal(form) {
    var formData = new FormData();
    formData.append("amount", form.amount);
    Object.entries(form).forEach((value) => {
      formData.append(value[0], value[1]);
    });

    return api
      .postForm("withdrawal", formData)
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }

        return res;
      });
  }

  async function withdrawal_bank(form) {
    return api
      .post("withdrawal_bank", form)
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }

        return res;
      });
  }

  async function member_withdrawal_bank(form) {
    return api
      .post("member_withdrawal_bank", form)
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }

        return res;
      });
  }

  async function get_withdrawal_limit(form) {
    return api
      .post("get_withdrawal_limit", form)
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }

        return res;
      });
  }

  async function bonus_a_page_list(form) {
    return api
      .post("bonus_a_page_list", form)
      .then((res) => res.data)
      .then((res) => {
        if (!res.status) {
          return res;
        }

        return res;
      });
  }

  async function deposit_frontend(form = {}) {
    try {
      const res = await api.post("deposit_frontend", form);
      return res.data;
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to load deposit",
      };
    }
  }

  async function deposit(form = {}) {
    try {
      const payload = { ...form };
      const { attachment, deposit_type: _depositType, ...rest } = payload;
      const body =
        attachment instanceof File
          ? (() => {
              const fd = new FormData();
              Object.entries(rest).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                  fd.append(key, value);
                }
              });
              fd.append("attachment", attachment);
              return fd;
            })()
          : rest;

      const res = await api.post("deposit", body);
      return res.data;
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Deposit failed",
      };
    }
  }

  async function deposit_check(form = {}) {
    try {
      const res = await api.post("deposit_check", form);
      return res.data;
    } catch (error) {
      return { status: false, message: "Failed to check deposit status" };
    }
  }

  async function deposit_cancel(form = {}) {
    try {
      const res = await api.post("deposit_cancel", form);
      return res.data;
    } catch (error) {
      return { status: false, message: "Failed to cancel deposit" };
    }
  }
}
